import { Avatar, Button, Divider, Drawer, IconButton, Typography, Box } from '@mui/material';
import { generatePath, Link } from 'react-router-dom';
import { CloseIcon } from '../../../assets/icons';
import { useGetSignedInUser } from '../../../hooks/useGetSignedInUser';
import { APP_URLS } from '../../../routes/urls';
import { MenuWithChildren } from '../../../types/menu';
import { AppIcon } from '../../app-icon/AppIcon';
import { ADMIN_REGISTER_MENUS } from '../constants';
import { MobileHeaderMenuList } from './MobileHeaderMenuList';
import { mobileHeaderStyles } from './styles';

interface MobileHeaderDrawerProps {
  menus: MenuWithChildren[];
  isDrawerOpen: boolean;
  onDrawerClose: () => void;
}

export const MobileHeaderDrawer: React.FC<MobileHeaderDrawerProps> = ({ menus, isDrawerOpen, onDrawerClose }) => {
  const { isSuccess, currentData: userData } = useGetSignedInUser();
  const isUserSignedIn = isSuccess && userData?.user;
  const getProfileUrl = () => {
    if (isUserSignedIn) {
      return generatePath(APP_URLS.profile, {
        studentSlug: userData.user?.slug,
      });
    }
    return APP_URLS.signIn;
  };
  return (
    <Drawer open={isDrawerOpen} anchor="left" onClose={onDrawerClose}>
      <Box width="clamp(15rem, 85vw, 25rem)">
        <Box px={1} py={2}>
          <IconButton color="secondary" sx={{ mb: 2.5 }} aria-label="Close Menu" onClick={onDrawerClose}>
            <AppIcon fontSize="small" titleAccess="Close Menu" Icon={CloseIcon} />
          </IconButton>
          {isUserSignedIn && userData.user ? (
            <Button component={Link} to={getProfileUrl()} sx={mobileHeaderStyles.drawerProfileBtn}>
              <Avatar alt={userData.user.full_name} src={userData.user.media} sx={{ mr: 2 }} />
              <Box>
                <Typography color="common.black" variant="body1" fontWeight="Medium">
                  {userData.user.full_name}
                </Typography>
                <Typography color="primary" variant="small">
                  View Profile
                </Typography>
              </Box>
            </Button>
          ) : (
            <Button component={Link} to={APP_URLS.signIn} sx={mobileHeaderStyles.drawerSignInBtn}>
              <Typography color="secondary">You are not logged in currently.</Typography>
              Sign In Now
            </Button>
          )}
        </Box>
        <Divider />
        <Box px={1} py={2}>
          <MobileHeaderMenuList subHeader="Explore Menus" subHeaderId="header-explore-menus-heading" menus={menus} />
        </Box>
        <Divider />
        <Box px={1} py={2}>
          <MobileHeaderMenuList
            subHeader="Register as Admin"
            subHeaderId="header-register-as-admin-heading"
            menus={ADMIN_REGISTER_MENUS}
          />
        </Box>
      </Box>
    </Drawer>
  );
};
